/* hzo-cart.js — de eigen winkelwagen aansturen.
 *
 * WAT DIT BESTAND WEL DOET: de kopknop omleiden naar onze lade, de wagen
 * bijwerken na elke wijziging, varianten omwisselen, de upsell vullen en de
 * kortingstrap invullen.
 *
 * WAT DIT BESTAND NIET DOET: rekenen. Alle bedragen komen uit Liquid, doordat
 * we na elke wijziging de sectie opnieuw laten renderen door Shopify. Zou dit
 * script de prijzen zelf optellen, dan heb je twee rekenmachines en lopen ze
 * een keer uit de pas — precies zoals de prijskleur in het snel-toevoegen-blad
 * ooit van de productpagina afweek.
 */
(() => {
  if (window.__hzoWagen) return;
  window.__hzoWagen = true;

  const echteFetch = window.fetch.bind(window);

  /* DE TREDES KOMEN UIT DE OPMAAK, NIET UIT DIT BESTAND.
   *
   * Ze stonden hier ooit als lijst én in hzo-cart-inhoud.liquid als tekst in de
   * rail. Twee bronnen voor dezelfde vier getallen: wie er één aanpast krijgt een
   * balk die iets anders zegt dan de regel erboven, en niets waarschuwt.
   *
   * Liquid tekent nu de rail en schrijft dezelfde reeks weg in
   * `data-hzo-tredes`. Wij lezen hem daar. De lijst hieronder is puur een
   * vangnet voor het geval de wagen zonder dat attribuut wordt gerenderd. */
  const TREDES_TERUGVAL = [
    { vanaf: 2, pct: 10 },
    { vanaf: 3, pct: 15 },
    { vanaf: 4, pct: 20 },
    { vanaf: 5, pct: 25 },
  ];

  function tredes() {
    const trap = document.querySelector('[data-hzo-trap]');
    const ruw = trap && trap.dataset.hzoTredes;
    if (ruw) {
      try {
        const lijst = JSON.parse(ruw);
        if (Array.isArray(lijst) && lijst.length) {
          return lijst
            .filter((t) => Number.isFinite(+t.vanaf) && Number.isFinite(+t.pct))
            .map((t) => ({ vanaf: +t.vanaf, pct: +t.pct }))
            .sort((a, b) => a.vanaf - b.vanaf);
        }
      } catch (e) {
        /* stil: liever de terugval dan een winkelwagen die niet meer werkt */
      }
    }
    return TREDES_TERUGVAL;
  }

  const wagen = () => document.querySelector('[data-hzo-wagen]');
  const lade = () => wagen()?.closest('theme-drawer');

  /* De sectie-id staat in de wikkel die Shopify eromheen zet. Uitlezen in
     plaats van intypen: hij verandert zodra de sectie een andere naam krijgt in
     de sectiegroep, en dan zou een ingetypte naam stilletjes stoppen met werken. */
  function sectieId() {
    const w = wagen()?.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }

  /* ── de lade openen ───────────────────────────────────────────────────── */
  function open() {
    const l = lade();
    if (!l) return;
    if (typeof l.open === 'function') l.open();
    else l.querySelector('dialog')?.showModal();
  }

  /* IEDERE KNOP OPENT DE WAGEN OP DEZELFDE MANIER.
     Horizon heeft een klasse `theme-drawer__dialog-instant` die de animatie
     uitzet (`animation: none`). Die zette hij op onze lade zodra je op de
     plakknop onderaan de productpagina drukte: de wagen ploepte er dan ineens
     staan, terwijl hij bij de gewone koopknop netjes inschuift. Dat verschil
     zag de eigenaar meteen.

     De klasse wordt na `open()` gezet, dus hem daar weghalen helpt niet; een
     waarnemer op het klassenattribuut haalt hem weg wanneer hij ook opduikt.
     Hij staat óók de sluitanimatie in de weg, want in Horizons stylesheet komt
     `-instant` ná `--closing` en dan wint hij bij gelijke specificiteit. */
  const GEEN_ANIMATIE = 'theme-drawer__dialog-instant';
  let wacht = null;
  function animatieBewaken() {
    const d = lade()?.querySelector('dialog');
    if (!d || d === wacht) return;
    wacht = d;
    d.classList.remove(GEEN_ANIMATIE);
    new MutationObserver(() => {
      if (d.classList.contains(GEEN_ANIMATIE)) d.classList.remove(GEEN_ANIMATIE);
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  /* De kopknop wijst naar Horizons eigen lade (`on:click="#cart-drawer/toggle"`).
     We vangen de klik af in de capture-fase, vóór die koppeling, en openen de
     onze. Het kenmerk halen we er ook af, voor het geval de koppeling later
     alsnog gelegd wordt. */
  function knopOvernemen() {
    document.querySelectorAll('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]').forEach((k) => {
      k.removeAttribute('on:click');
    });
  }

  document.addEventListener(
    'click',
    (e) => {
      const knop = e.target.closest?.('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]');
      if (!knop || !wagen()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    },
    true
  );

  /* ── bijwerken ────────────────────────────────────────────────────────────
     Shopify rendert onze sectie opnieuw en wij wisselen alleen de binnenkant om.
     Het `<dialog>` zelf blijft staan: dat vervangen zou de lade dichtklappen
     midden in een handeling. */
  function vervang(html) {
    if (!html) return;
    const oud = wagen();
    if (!oud) return;
    const nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hzo-wagen]');
    if (!nieuw) return;
    oud.replaceWith(nieuw);
    naVerversen();
  }

  async function muteer(lichaam) {
    const id = sectieId();
    const w = wagen();
    if (w) w.dataset.hzoBezig = 'true';
    try {
      const r = await echteFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...lichaam, sections: id }),
      });
      const data = await r.json();
      vervang(data.sections?.[id]);
      return data;
    } catch (e) {
      melden('Something went wrong. Try again.');
      if (w) delete w.dataset.hzoBezig;
      return null;
    }
  }

  async function verversAlleen() {
    const id = sectieId();
    if (!id) return;
    try {
      const html = await echteFetch(`${location.pathname}?sections=${id}`).then((r) => r.json());
      vervang(html?.[id]);
    } catch (e) {
      /* stil: liever een wagen die niet ververst dan een pagina die stukloopt */
    }
  }

  function melden(tekst) {
    const w = wagen();
    if (!w) return;
    let m = w.querySelector('[data-hzo-melding]');
    if (!m) {
      m = document.createElement('p');
      m.className = 'hzo-wagen__fout';
      m.setAttribute('data-hzo-melding', '');
      w.querySelector('.hzo-wagen__regels')?.before(m);
    }
    m.textContent = tekst;
  }

  /* DIRECT VERSPRINGEN, NIET GEANIMEERD.
     Ik dacht eerst dat `behavior: 'smooth'` stuk was: de carrousel sprong
     steeds terug naar het begin. Dat was mijn meetopstelling. In een
     geautomatiseerd browservenster vuurt `requestAnimationFrame` niet, en daar
     hangt vloeiend scrollen aan — dus er gebeurde gewoon niets, en mijn eigen
     animatie liep om dezelfde reden vast.

     Een sprong die het altijd doet is meer waard dan een animatie die ik niet
     kan nakijken. Met scroll-snap erop landt hij toch netjes op een kaart. */
  function schuifNaar(el, doel) {
    el.scrollLeft = Math.max(0, Math.min(doel, el.scrollWidth - el.clientWidth));
  }

  /* ── klikken binnen de wagen ─────────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const weg = e.target.closest?.('[data-hzo-weg]');
    if (weg && wagen()) {
      e.preventDefault();
      const regel = weg.closest('[data-hzo-regel]');
      if (regel) await muteer({ line: Number(regel.dataset.regel), quantity: 0 });
      return;
    }

    const up = e.target.closest?.('[data-hzo-up-add]');
    if (up) {
      e.preventDefault();
      await upsellToevoegen(up);
      return;
    }

    /* DE PIJLTJES OP HET DOCUMENT, NIET OP DE KNOP ZELF.
       Ze zaten eerst in `upsellVullen`, en die hangt zijn luisteraars op de
       knoppen van dát moment. Bij elke wijziging vervangt Shopify de sectie en
       zijn die knoppen weg, luisteraar en al — het pijltje leek dan stuk.
       Via het document blijft het werken, hoe vaak de wagen ook opnieuw
       getekend wordt.

       Eén kaart per klik: over meerdere kaarten tegelijk springen maakt het
       onduidelijk waar je bent. Elke kaart beslaat precies één baanbreedte
       (kaart + de marge links en rechts), dus dat is de stap. De oude
       "kaartbreedte + 10" klopte nog toen de volgende kaart eronderuit stak. */
    const pijl = e.target.closest?.('[data-hzo-up-terug], [data-hzo-up-verder]');
    if (pijl && !pijl.disabled) {
      e.preventDefault();
      const veeg = pijl.parentElement.querySelector('[data-hzo-up-veeg]');
      if (!veeg) return;
      const stap = veeg.clientWidth;
      const richting = pijl.hasAttribute('data-hzo-up-verder') ? 1 : -1;
      schuifNaar(veeg, veeg.scrollLeft + richting * stap);

      /* De uiteinden hier meteen bijwerken. De scroll-luisteraar hangt aan het
         element dat bij het vullen bestond, en na een verversing is dat een
         ander; dan bleef het terug-pijltje aanklikbaar terwijl je al helemaal
         links stond. */
      const wp = pijl.parentElement;
      const t = wp.querySelector('[data-hzo-up-terug]');
      const v = wp.querySelector('[data-hzo-up-verder]');
      /* De baan heeft geen binnenmarge meer (die zit nu op de kaart zelf), dus
         de rustpositie is gewoon 0. Vroeger stond de eerste kaart op 14 en liet
         een vergelijking met 0 het terug-pijltje altijd aanklikbaar. */
      const rust = (parseFloat(getComputedStyle(veeg).paddingLeft) || 0) + 2;
      if (t) t.disabled = veeg.scrollLeft <= rust;
      if (v) v.disabled = veeg.scrollLeft >= veeg.scrollWidth - veeg.clientWidth - 2;
    }
  });

  /* ── kleur of maat wisselen ───────────────────────────────────────────────
     Shopify kan een regel niet van variant laten wisselen. Het moet dus in één
     `update.js`: de oude variant op 0 en de nieuwe op hetzelfde aantal. In één
     aanroep, want in twee stappen ziet de klant zijn artikel even verdwijnen. */
  document.addEventListener('change', async (e) => {
    const keuze = e.target.closest?.('[data-hzo-optie]');
    if (!keuze) return;
    const regel = keuze.closest('[data-hzo-regel]');
    if (!regel) return;

    const gekozen = [...regel.querySelectorAll('[data-hzo-optie]')].map((s) => s.value);
    let varianten = [];
    try {
      varianten = JSON.parse(regel.querySelector('[data-hzo-varianten]')?.textContent || '[]');
    } catch (err) {
      return;
    }

    const doel = varianten.find(
      (v) => v.opties.length === gekozen.length && v.opties.every((o, i) => o === gekozen[i])
    );

    if (!doel) {
      melden('That combination is not available.');
      return;
    }
    if (!doel.beschikbaar) {
      melden('That one is sold out.');
      return;
    }

    const oud = regel.dataset.variant;
    const aantal = 1;
    const id = sectieId();
    const w = wagen();
    if (w) w.dataset.hzoBezig = 'true';

    try {
      const r = await echteFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: { [oud]: 0, [doel.id]: aantal },
          sections: id,
        }),
      });
      const data = await r.json();
      vervang(data.sections?.[id]);
    } catch (err) {
      melden('Could not switch that. Try again.');
      if (w) delete w.dataset.hzoBezig;
    }
  });

  /* ── de kortingstrap ──────────────────────────────────────────────────────
     Alleen in wagen A. Het percentage staat hier, het BEDRAG niet: dat komt uit
     Liquid en verschijnt alleen als de kassa echt korting geeft. Zolang die
     korting niet in Shopify staat toont de trap dus wel de trede maar geen
     afgetrokken bedrag, en dat is eerlijk. */
  /* De hoogst gehaalde trede van de vórige keer. Dit staat MET OPZET hier en niet
     op het element: bij elke wijziging in de wagen haalt `verversAlleen()` verse
     HTML op en vervangt de hele trap, dus alles wat je op dat element zet is een
     tel later weg. Gemeten op 17 aug 2026: de zwaai vuurde geen enkele keer,
     omdat `dataset.hzoVorigeTrede` bij het teruglezen altijd leeg was.
     `null` betekent: nog nooit getekend, dus niet bewegen. */
  let vorigeTrede = null;

  function trapVullen() {
    const w = wagen();
    const trap = w?.querySelector('[data-hzo-trap]');
    if (!trap) return;

    const aantal = Number(w.dataset.aantal || 0);
    if (aantal < 1) {
      trap.hidden = true;
      return;
    }

    /* HET SLOT. De trap toont vijf tredes met percentages; als het afrekenen
       vervolgens niets aftrekt is dat een loze belofte, en dat is erger dan geen
       trap. Vanaf twee artikelen hóórt er korting af te gaan. Gaat er niets af,
       dan verbergen we de trap in plaats van hem te laten liegen.

       Dit is met opzet een slot op het tonen zelf en geen waarschuwing achteraf.
       De eigenaar kan het openzetten met "Always show the ladder" in de sectie,
       en in de thema-editor staat het altijd open, anders kun je je eigen ontwerp
       niet bekijken. */
    const stappen = tredes();
    if (!stappen.length) {
      trap.hidden = true;
      return;
    }

    const korting = Number(w.dataset.korting || 0);
    const altijd = w.dataset.trapAltijd === '1';
    if (!altijd && aantal >= stappen[0].vanaf && korting <= 0) {
      trap.hidden = true;
      return;
    }
    trap.hidden = false;

    const volgende = stappen.find((t) => aantal < t.vanaf);
    const top = stappen[stappen.length - 1];

    const nu = trap.querySelector('[data-hzo-trap-nu]');
    const vul = trap.querySelector('[data-hzo-trap-vul]');

    /* Rechts staat wat er nog te halen valt, of wat je al hebt. Een trap die
       blijft duwen terwijl er niets meer te halen is, gaat irriteren.
       De controles hieronder zijn er omdat een volgende winkel deze opmaak kan
       inkorten: dan gebeurt er niets, in plaats van dat de hele wagen stilvalt. */
    if (nu) {
      if (volgende) {
        const tekort = volgende.vanaf - aantal;
        nu.innerHTML = `Add ${tekort} more for <b>${volgende.pct}% off</b>`;
      } else {
        nu.innerHTML = `<b>${top.pct}% off</b> unlocked`;
      }
    }

    /* De knopen staan op 1, 2, 3, 4 en 5+, dus vijf stuks en vier vakken ertussen.
       De vulling loopt tot het MIDDEN van de laatst gehaalde knoop; daarom delen
       we door het aantal tussenruimtes en niet door het aantal knopen. */
    const knopen = trap.querySelectorAll('[data-hzo-trede]');
    let bereikt = 0;
    let hoogsteTrede = 0;
    knopen.forEach((k, i) => {
      const trede = Number(k.dataset.hzoTrede);
      const aan = aantal >= trede;
      if (aan) { bereikt = i; hoogsteTrede = trede; }
      k.classList.toggle('hzo-trap__knoop--aan', aan);
      k.classList.toggle('hzo-trap__knoop--volgend', !aan && aantal + 1 >= trede);
    });

    /* ── DE ZWAAI ──────────────────────────────────────────────────────────
       Alleen het kaartje dat NET van toestand wisselt beweegt. We onthouden de
       hoogste gehaalde TREDE en niet de plek in de rij: zet iemand de tredes
       later anders neer, dan is plek 2 iets anders geworden en zwaait het
       verkeerde kaartje.

       Bij de eerste keer tekenen staat er nog niets onthouden en gebeurt er dus
       niets — anders danst de hele rij zodra je de lade opent.

       De klas gaat er eerst af en na een tik weer op. Zonder die tussenstap
       merkt de browser geen verandering en speelt dezelfde animatie een tweede
       keer niet af, en dat is precies wat er gebeurt als je twee keer achter
       elkaar hetzelfde artikel toevoegt en weer weghaalt. */
    if (vorigeTrede !== null) {
      const vorige = vorigeTrede;
      if (hoogsteTrede !== vorige) {
        const omhoog = hoogsteTrede > vorige;
        const laag = Math.min(vorige, hoogsteTrede);
        const hoog = Math.max(vorige, hoogsteTrede);
        knopen.forEach((k) => {
          const trede = Number(k.dataset.hzoTrede);
          if (trede <= laag || trede > hoog) return;
          const klas = omhoog ? 'hzo-trap__knoop--zwaai' : 'hzo-trap__knoop--zak';
          k.classList.remove('hzo-trap__knoop--zwaai', 'hzo-trap__knoop--zak');
          requestAnimationFrame(() => {
            requestAnimationFrame(() => k.classList.add(klas));
          });
          const kaart = k.querySelector('.hzo-trap__kaart');
          if (kaart) {
            kaart.addEventListener('animationend', () => {
              k.classList.remove('hzo-trap__knoop--zwaai', 'hzo-trap__knoop--zak');
            }, { once: true });
          }
        });
      }
    }
    vorigeTrede = hoogsteTrede;
    /* DE VULLING IS EEN calc(), GEEN PERCENTAGE MEER (17 aug 2026, avond).
       De baan loopt sinds de kaartjes van rand tot rand van de lade, en de
       kaartjes staan binnen de kantlijn. Een percentage van die bredere baan
       landt dus niet meer op een rijggat. De maten blijven in CSS staan
       (`--hzo-trap-uit` en `--hzo-trap-kaart`); hier gaat alleen de breuk in. */
    if (vul && knopen.length > 1) {
      const deel = bereikt / (knopen.length - 1);
      vul.style.width =
        'calc(var(--hzo-trap-uit) + var(--hzo-trap-kaart) / 2' +
        ' + (100% - 2 * var(--hzo-trap-uit) - var(--hzo-trap-kaart)) * ' + deel + ')';
    }
    trap.classList.toggle('hzo-trap--klaar', !volgende);
  }

  /* ── de upsell ────────────────────────────────────────────────────────────
     Eén kaart in beeld met de volgende die eronderuit steekt. Komt er niets
     terug, dan blijft het hele vak weg in plaats van een lege strook achter te
     laten. */
  const upsellCache = new Map();

  async function upsellVullen() {
    const w = wagen();
    const vak = w?.querySelector('[data-hzo-up]');
    if (!vak) return;

    const productId = w.dataset.eersteProduct;
    if (!productId) {
      vak.hidden = true;
      return;
    }

    /* ONTHOUDEN. Deze functie draait na ELKE wijziging in de wagen — aantal
       omhoog, regel weg, variant anders. De aanbevelingen hangen alleen aan het
       eerste product, dus dat leverde bij elke klik opnieuw 410 kB over de lijn
       voor exact dezelfde zes producten. Nu één keer per product. */
    let producten = upsellCache.get(productId);
    if (!producten) {
      try {
        const d = await echteFetch(
          `/recommendations/products.json?product_id=${productId}&limit=6&intent=related`
        ).then((r) => r.json());
        producten = (d.products || []).filter((p) => p.available);
        upsellCache.set(productId, producten);
      } catch (e) {
        vak.hidden = true;
        return;
      }
    }

    if (!producten.length) {
      vak.hidden = true;
      return;
    }

    const soort = w.dataset.soort;
    const aantal = Number(w.dataset.aantal || 0);
    const volgende = tredes().find((t) => aantal < t.vanaf);
    const kop = vak.querySelector('[data-hzo-up-kop]');

    if (kop) {
      if (soort === 'trap' && volgende) {
        kop.textContent = `One more unlocks ${volgende.pct}% off`;
        kop.classList.add('hzo-up__kop--actie');
      } else {
        kop.textContent = 'You might also like';
        kop.classList.remove('hzo-up__kop--actie');
      }
    }

    const veeg = vak.querySelector('[data-hzo-up-veeg]');
    if (!veeg) return;
    veeg.innerHTML = '';
    producten.forEach((p) => veeg.appendChild(kaartMaken(p)));


    /* de pijltjes uitzetten aan de uiteinden, zodat je niet op een dode knop
       drukt */
    const terug = vak.querySelector('[data-hzo-up-terug]');
    const verder = vak.querySelector('[data-hzo-up-verder]');

    function bijwerken() {
      const rust = (parseFloat(getComputedStyle(veeg).paddingLeft) || 0) + 2;

      /* GEEN OORDEEL ZONDER MAAT. Staat de lade dicht, dan heeft alles erin
         breedte nul, en dan zou de rekensom hieronder allebei de pijltjes
         uitzetten. Niets doen is dan het juiste antwoord: de waarnemer verderop
         roept deze functie opnieuw aan zodra het vak wel breedte heeft. */
      if (!veeg.clientWidth) return;

      if (terug) terug.disabled = veeg.scrollLeft <= rust;
      if (verder) verder.disabled = veeg.scrollLeft >= veeg.scrollWidth - veeg.clientWidth - 2;
    }

    /* WAAROM ÉÉN KEER METEN NIET GENOEG WAS.
       `bijwerken()` liep precies één keer, vlak na het vullen van de baan — en op
       dat moment staat de lade meestal nog DICHT. Een element in een gesloten
       <dialog> heeft geen afmetingen: `scrollWidth` en `clientWidth` zijn allebei
       0, dus `0 >= 0 - 0 - 2` is waar en het verder-pijltje ging op `disabled`.
       Daarna vuurde alleen nog `scroll`, en scrollen kan niet zonder pijltje.

       Op de telefoon kwam het vanzelf goed zodra je met je vinger veegde; op het
       bureaublad bleven allebei de pijltjes weg. Dat is wat de eigenaar zag.

       Gemeten op de winkel, 17 aug 2026: 6 kaarten, `scrollWidth` 2874 tegen
       `clientWidth` 479 op het bureaublad en 2058 tegen 343 op de telefoon — er
       viel dus wel degelijk te schuiven, en toch stonden beide op `disabled`.

       Een waarnemer op de MAAT is het antwoord: die vuurt zodra de lade opengaat
       en het vak breedte krijgt, en ook als het scherm draait of van formaat
       verandert. De luisteraars worden één keer per baan gehangen — deze functie
       draait namelijk na ELKE wijziging in de wagen, en zonder dat slot zou er
       bij elke klik een luisteraar bij komen. Wordt de sectie opnieuw getekend,
       dan is `veeg` een nieuw element zonder vlaggetje en gebeurt het opnieuw. */
    if (!veeg.dataset.hzoUpKijkt) {
      veeg.dataset.hzoUpKijkt = '1';
      veeg.addEventListener('scroll', bijwerken);
      if (window.ResizeObserver) new ResizeObserver(bijwerken).observe(veeg);
    }

    vak.hidden = false;
    bijwerken();
  }

  function kaartMaken(p) {
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const kaart = document.createElement('div');
    kaart.className = 'hzo-upkaart';

    const beeld = document.createElement('a');
    beeld.className = 'hzo-upkaart__beeld';
    beeld.href = p.url;
    if (p.featured_image) {
      const img = document.createElement('img');
      img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
      img.alt = '';
      img.loading = 'eager';   /* lazy laadde pas als de lade al openstond: het vak verscheen leeg (12 okt 2026) */
      beeld.appendChild(img);
    }

    const lijf = document.createElement('div');
    lijf.className = 'hzo-upkaart__lijf';

    const naam = document.createElement('a');
    naam.className = 'hzo-upkaart__naam';
    naam.href = p.url;
    naam.textContent = p.title;

    const prijs = document.createElement('p');
    prijs.className = 'hzo-upkaart__prijs';
    const was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
    prijs.innerHTML = was
      ? `<span class="hzo-wprijs__was">${geld(was)}</span><span class="hzo-wprijs__nu--sale">${geld(v.price)}</span>`
      : geld(v.price);

    const rij = document.createElement('div');
    rij.className = 'hzo-upkaart__rij';

    const kies = document.createElement('select');
    kies.className = 'hzo-minivak__select';
    p.variants
      .filter((x) => x.available)
      .forEach((x) => {
        const o = document.createElement('option');
        o.value = x.id;
        o.textContent = x.title === 'Default Title' ? 'One size' : x.title;
        kies.appendChild(o);
      });

    const knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'hzo-upkaart__add';
    knop.setAttribute('data-hzo-up-add', '');
    knop.textContent = 'Add';

    rij.append(kies, knop);
    lijf.append(naam, prijs, rij);
    kaart.append(beeld, lijf);
    return kaart;
  }

  async function upsellToevoegen(knop) {
    const kaart = knop.closest('.hzo-upkaart');
    const kies = kaart?.querySelector('select');
    if (!kies) return;
    const id = sectieId();
    /* HET LABEL BLIJFT STAAN. Eerst zette ik er "Adding…" in en pinde de breedte
       vast tegen het opzij springen van de rij — maar dan valt het woord buiten
       de knop en staat het scheef. Nu verandert er niets aan de maat: de tekst
       wordt doorzichtig en de CSS zet er drie puntjes overheen, gecentreerd. */
    knop.disabled = true;
    knop.dataset.hzoBezig = '';
    try {
      const r = await echteFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(kies.value), quantity: 1 }], sections: id }),
      });
      const data = await r.json();
      if (data.status) {
        knop.disabled = false;
        delete knop.dataset.hzoBezig;
        melden(data.description || 'Could not add that one.');
        return;
      }
      vervang(data.sections?.[id]);
    } catch (e) {
      knop.disabled = false;
      delete knop.dataset.hzoBezig;
      melden("Couldn't add that one. Check your connection and try again.");
    }
  }

  /* GELD OPMAKEN MET HET FORMAAT VAN DE WINKEL.
   *
   * Hier stond `Shopify.formatMoney` met een dollarteken als terugval. Die functie
   * bestaat in Horizon NIET (gemeten: `Shopify.formatMoney` is undefined), dus de
   * terugval was in de praktijk het enige pad — en die schreef $ op elke winkel,
   * ook op een winkel in euro's.
   *
   * Liquid geeft nu `shop.money_format` mee op de wagen. Dat is dezelfde reeks
   * die Shopify zelf gebruikt, dus komma's, punten en het teken kloppen per
   * winkel zonder dat hier iets over valuta hoeft te staan. */
  function geld(cent) {
    const formaat = wagen()?.dataset.geldformaat || '${{amount}}';

    /* Duizendtallen groeperen. LET OP: dit moet op het HELE getal gebeuren, VOOR
       je er een decimaalteken in zet. Mijn eerste versie zette eerst de komma en
       liet de regex daarna los op "1234,56"; de vooruitblik botst dan op die
       komma en er kwam nooit een scheidingsteken uit. Zichtbaar vanaf duizend, en
       alleen op winkels met een komma als decimaalteken -- precies het soort fout
       dat je bij het overzetten pas maanden later ontdekt. */
    const groepeer = (heel, teken) => heel.replace(/\B(?=(\d{3})+(?!\d))/g, teken);

    const bedrag = (token) => {
      const n = Math.abs((cent || 0) / 100);
      const min = (cent || 0) < 0 ? '-' : '';
      const heel = String(Math.floor(n));
      const decimalen = n.toFixed(2).slice(-2);

      switch (token) {
        case 'amount_no_decimals':
          return min + groepeer(String(Math.round(n)), ',');
        case 'amount_with_comma_separator':
          return min + groepeer(heel, '.') + ',' + decimalen;
        case 'amount_no_decimals_with_comma_separator':
          return min + groepeer(String(Math.round(n)), '.');
        case 'amount_with_apostrophe_separator':
          return min + groepeer(heel, "'") + '.' + decimalen;
        case 'amount_no_decimals_with_space_separator':
          return min + groepeer(String(Math.round(n)), ' ');
        case 'amount_with_space_separator':
          return min + groepeer(heel, ' ') + ',' + decimalen;
        default: // amount
          return min + groepeer(heel, ',') + '.' + decimalen;
      }
    };
    return formaat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => bedrag(token));
  }

  /* ── na elke verversing ─────────────────────────────────────────────────── */
  function naVerversen() {
    trapVullen();
    upsellVullen();
  }

  /* ── toevoegen elders op de site ──────────────────────────────────────────
     Wordt er ergens een artikel toegevoegd (productpagina, snel-toevoegen), dan
     moet onze wagen bijwerken én opengaan. We kijken naar de aanvraag zelf in
     plaats van naar een gebeurtenis van het thema: dat werkt ongeacht welk
     onderdeel het toevoegen deed. */
  /* ÉÉN RONDE NAAR DE SERVER BIJ TOEVOEGEN (12 okt 2026).
     Eerst ging het zo: /cart/add, dan pas een tweede aanvraag voor onze sectie,
     dan pas de lade open. Op een telefoon is elke ronde 0,2–0,5 s, en in de opname
     verscheen de lade terwijl de inhoud nog versprong. Shopify geeft de sectie mee
     als je hem in `sections` van dezelfde aanvraag zet; Horizon doet dat zelf al
     voor zijn eigen wagen. We hangen er de onze bij. Lukt dat niet (ander soort
     aanvraag, of de sectie zit niet in het antwoord), dan de oude weg. */
  function metOnzeSectie(opties, id) {
    try {
      const b = opties && opties.body;
      if (!b) return opties;
      if (b instanceof FormData || b instanceof URLSearchParams) {
        const s = b.get('sections');
        b.set('sections', s ? `${s},${id}` : id);
        return opties;
      }
      if (typeof b === 'string' && b.trim().startsWith('{')) {
        const j = JSON.parse(b);
        if (Array.isArray(j.sections)) j.sections = [...j.sections, id];
        else j.sections = j.sections ? `${j.sections},${id}` : id;
        return { ...opties, body: JSON.stringify(j) };
      }
    } catch (e) {
      /* stil: dan gaat de aanvraag zoals hij was */
    }
    return opties;
  }

  window.fetch = function (bron, opties) {
    const adres = typeof bron === 'string' ? bron : bron && bron.url;
    const ookWagen = adres && /\/cart\/(add|change|update|clear)/.test(adres) && !/hzo-intern/.test(adres);
    const isToevoegen = ookWagen && /\/cart\/add/.test(adres);
    const id = isToevoegen ? sectieId() : null;
    if (id) opties = metOnzeSectie(opties, id);
    const belofte = echteFetch(bron, opties);
    if (ookWagen) {
      belofte
        .then((r) => {
          if (!r.ok) return r;
          const oudeWeg = () => setTimeout(() => verversAlleen().then(() => {
            animatieBewaken();
            if (isToevoegen) open();
          }), 60);
          if (!id) {
            oudeWeg();
            return r;
          }
          r.clone().json()
            .then((j) => {
              const html = j && j.sections && j.sections[id];
              if (!html) return oudeWeg();
              vervang(html);
              animatieBewaken();
              open();
            })
            .catch(oudeWeg);
          return r;
        })
        .catch(() => {});
    }
    return belofte;
  };

  /* Horizons eigen lade mag niet vanzelf opengaan naast de onze. */
  function horizonUitzetten() {
    document.querySelectorAll('cart-drawer-component[auto-open]').forEach((c) => c.removeAttribute('auto-open'));
  }

  /* ÉÉN WAGEN TEGELIJK.
     Er staan twee wagensecties in de voettekstgroep: Pre (balk met gratis
     verzending en retour) en Post (kortingstrap). Er hoort er precies
     één zichtbaar te staan. Zet iemand ze allebei aan, dan pakt dit script de
     eerste en zou de tweede als dode lade in de pagina blijven hangen: onzichtbaar,
     maar hij vangt wel focus en een schermlezer leest hem voor.

     Liever hier hard afsluiten dan hopen dat het niet gebeurt. */
  function tweedeWagenUitzetten() {
    const alle = document.querySelectorAll('[data-hzo-wagen]');
    for (let i = 1; i < alle.length; i += 1) {
      const l = alle[i].closest('theme-drawer');
      if (!l) continue;
      l.querySelector('dialog')?.close?.();
      l.style.display = 'none';
      l.setAttribute('aria-hidden', 'true');
    }
  }

  /* ── een lade die al openstond voordat er geklikt is ──────────────────────
     `no-persist` op de sectie zorgt dat onze wagen niet meer wordt onthouden.
     Maar wie op dit moment al aan het winkelen is, heeft de oude waarde nog in
     `sessionStorage` staan, en Horizons herstelscript draait synchroon tijdens
     het inlezen van de HTML — dus vóór dit bestand. Die ene keer ruimen we hier op.

     Veilig op dit moment: `start()` draait bij DOMContentLoaded en dan heeft de
     bezoeker nog nergens op geklikt. Staat de lade open, dan komt dat uit het
     herstel en niet uit een handeling. */
  function herstelOpruimen() {
    try {
      const bewaard = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(Boolean);
      const onze = ['hzo-cart-a', 'hzo-cart-b'];
      const rest = bewaard.filter((id) => !onze.includes(id));
      if (rest.length !== bewaard.length) {
        if (rest.length) sessionStorage.setItem('theme-drawer-open', rest.join(','));
        else sessionStorage.removeItem('theme-drawer-open');
      }
    } catch (e) {
      /* stil: een winkel zonder sessieopslag mag hier niet op stukgaan */
    }
    onzeLades().forEach((l) => {
      if (l.hasAttribute('open')) {
        if (typeof l.close === 'function') l.close();
        else {
          l.removeAttribute('open');
          l.querySelector('dialog')?.close?.();
        }
      }
    });
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
  }

  function onzeLades() {
    return [...document.querySelectorAll('#hzo-cart-a, #hzo-cart-b')];
  }

  /* AANBEVELINGEN ALVAST OPHALEN (12 okt 2026).
     Na het eerste toevoegen haalde upsellVullen() pas de aanbevelingen op (410 kB),
     terwijl de lade al openstond: het gele vak verscheen later en duwde de rest
     opzij. Op een productpagina weten we al welk product als eerste in de wagen
     komt, dus we halen ze op zodra de pagina rustig is, met de eerste plaatjes erbij. */
  function upsellVooraf() {
    const id = document.querySelector('product-form-component[data-product-id]')?.dataset.productId;
    if (!id || upsellCache.has(id)) return;
    echteFetch(`/recommendations/products.json?product_id=${id}&limit=6&intent=related`)
      .then((r) => r.json())
      .then((d) => {
        const producten = (d.products || []).filter((p) => p.available);
        if (!upsellCache.has(id)) upsellCache.set(id, producten);
        producten.slice(0, 3).forEach((p) => {
          if (p.featured_image) new Image().src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
        });
      })
      .catch(() => {});
  }

  function start() {
    if (!wagen()) return;
    (window.requestIdleCallback || ((f) => setTimeout(f, 1500)))(upsellVooraf, { timeout: 4000 });
    herstelOpruimen();
    knopOvernemen();
    horizonUitzetten();
    tweedeWagenUitzetten();
    animatieBewaken();
    naVerversen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
